import { queryOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosClient } from "auth-sdk";
import type { CustomerDetailsSchemas } from "api-types";

import { CUSTOMER_BUSINESS_MODEL_API } from "../../components/constants";
import type { BusinessModelData } from "../../types";

export const getCustomerBusinessModelQueryOptions = (customerDomain: string) => {
  const url = CUSTOMER_BUSINESS_MODEL_API.replace(":customerSlug", customerDomain);
  return queryOptions({
    queryKey: [url],
    queryFn: () => axiosClient.get<BusinessModelData>(url),
    select: (data: { data: BusinessModelData }) => data.data,
    refetchOnMount: "always",
  });
};

export const useCustomerBusinessModelMutation = (customerDomain: string) => {
  const queryClient = useQueryClient();
  const url = CUSTOMER_BUSINESS_MODEL_API.replace(":customerSlug", customerDomain);
  return useMutation({
    mutationKey: ["update-customer-business-model", customerDomain],
    mutationFn: (data: CustomerDetailsSchemas.BusinessModelUpdateRequest) =>
      axiosClient.patch<CustomerDetailsSchemas.BusinessModelUpdateRequest>(url, data).then((res) => res.data),
    onSuccess: async () => {
      // Invalidate business model query
      await queryClient.invalidateQueries({ queryKey: [url] });
    },
  });
};
